import { SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';
import { getAllStudentsFormData } from '../../api';

export const useSearchStudents = () => {
  return useCallback(async (searchText: string): Promise<
    SelectOptionType[]
  > => {
    const { data } = await getAllStudentsFormData(searchText);
    if (!data) {
      return [];
    }
    return data.map((student) => ({
      label: student.name + ', ' + student.identification,
      value: student.accountId,
      studyPlanEnrollments: student.studyPlanEnrollments,
    }));
  }, []);
};
